export class ReportParams {
  to: string;
  from: string;
  type: string;
  name: string;
  code: string;
  reportName: string;
  tagIds: string[] = [];
  supervisor: string;
  supervisorName: string;
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/report-params.ts